import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'

// Runs whose output blob has not been analyzed yet carry no aspect ratio; those images
// render square.
const DEFAULT_ASPECT_RATIO = 1

// The backend sends the ratio as "width:height" (e.g. "3:2").
export const toAspectRatio = (aspectRatio) => {
  const [width, height] = String(aspectRatio ?? '').split(':').map(Number)
  return width > 0 && height > 0 ? width / height : DEFAULT_ASPECT_RATIO
}

// The image endpoints serialize a run rather than a gallery row, so its file and ratio sit
// on the output asset. Returns null when there is no file to show.
export const toModalImage = (attributes) => {
  if (!attributes) return null

  const {
    id, slug, title, prompt, createdAt, user, likeCount, outputAssets,
  } = attributes
  const { assetId, fileUrl, aspectRatio } = getAssetByTypeAndSource(outputAssets, 'image', 'ai_generated')
  if (!fileUrl) return null

  return {
    id,
    slug,
    assetId,
    title: title ?? prompt ?? '',
    prompt,
    createdAt,
    user,
    likeCount,
    src: fileUrl,
    aspectRatio: toAspectRatio(aspectRatio),
  }
}
